var Backend = (function () {
    function Backend() {
        Object.defineProperty(this, "namespaces", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "services", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    Object.defineProperty(Backend.prototype, "init", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (services, backendOptions) {
            var _this = this;
            this.services = services;
            backendOptions.modules.forEach(function (localizationModule) {
                localizationModule.namespaces.forEach(function (namespace) {
                    _this.namespaces[namespace] = function (language) {
                        return localizationModule.load(namespace, language);
                    };
                });
            });
        }
    });
    Object.defineProperty(Backend.prototype, "read", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (language, namespace, callback) {
            this.services.logger.log('Trying to read locales for:' + language + ' ' + namespace);
            if (this.namespaces[namespace]) {
                this.namespaces[namespace](language).then(function (data) {
                    callback(null, data);
                });
            }
            else {
                callback(new Error('Cannot found source to load namespace [' + namespace + ']'), {});
            }
        }
    });
    Object.defineProperty(Backend, "type", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'backend'
    });
    return Backend;
}());
export { Backend };
